import DiffusionSession from 'rp-diffusion-connector';
import { diffusionServiceUtils } from 'rp-prices-component';
import { flatMap, flow, skybetDiffusionName } from '../../helpers/utils';

const BOOKMAKERS = [
    'BET365',
    'BOLEYSPORTS',
    'BETFRED',
    'CORAL',
    'LADB',
    'PPWR',
    'TOTE',
    [skybetDiffusionName],
    'BETFAIR',
    'WH_OXI',
    'BETFRED',
];

export default class DiffusionProvider {
    constructor(pageConfig, horsesNames, {
        onInfo,
        onBestOdds,
        onPrice
    }) {
        this.pageConfig = pageConfig;
        this.horsesNames = horsesNames;
        this.onInfo = flow([
            diffusionServiceUtils.parseInfoTopicData,
            onInfo
        ]);
        this.onBestOdds = flow([
            diffusionServiceUtils.parsePriceTopicData,
            onBestOdds
        ]);
        this.onPrice = flow([
            diffusionServiceUtils.parsePriceTopicData,
            onPrice
        ]);
    }

    init() {
        const infoDiffusionSession = new DiffusionSession({ onDataFunction: this.onInfo });
        this.subscribeInfoTopics(infoDiffusionSession, BOOKMAKERS);
        const bestOddsDiffusionSession = new DiffusionSession({ onDataFunction: this.onBestOdds });
        this.subscribePriceTopics(bestOddsDiffusionSession, ['#BESTODDS'], this.horsesNames);
        const pricesDiffusionSession = new DiffusionSession({ onDataFunction: this.onPrice });
        this.subscribePriceTopics(pricesDiffusionSession, BOOKMAKERS, this.horsesNames);
    }

    /**
     * @private
     */
    subscribeInfoTopics(diffusionSession, bookmakersList) {
        const topics = bookmakersList
            .map(bookmaker => ({
                bookmaker,
                ...this.pageConfig,
            }))
            .map(diffusionServiceUtils.createInfoTopic);
        this.subscribe(diffusionSession, topics);
    }

    /**
     * @private
     */
    subscribePriceTopics(diffusionSession, bookmakersList, horsesNames) {
        const getRenderConfigsFromHorseName =
            flatMap(
                horseName => bookmakersList.map(
                    bookmaker => ({
                        bookmaker,
                        horseName,
                        ...this.pageConfig,
                    })
                )
            );
        const topics = getRenderConfigsFromHorseName(horsesNames)
            .map(diffusionServiceUtils.createPriceTopic);
        this.subscribe(diffusionSession, topics);
    }

    /**
     * @private
     */
    subscribe(diffusionSession, topics) {
        const validTopics = topics.filter(topic => topic);
        diffusionSession.subscribe({ topics: validTopics });
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/oddsTabHandler/DiffusionProvider.js